import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { Factura } from '../../../types';
import { formatCurrency } from '../../../utils/formatters';

interface GraficaIngresosProps {
  facturas: Factura[];
}

// Custom tooltip component
const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white shadow-lg rounded-lg p-3 border border-gray-100">
        <p className="text-sm font-medium text-gray-600">Mes: {label}</p>
        <p className="text-lg font-bold text-blue-600">
          {formatCurrency(payload[0].value)}
        </p>
      </div>
    );
  }
  return null;
};

const GraficaIngresos: React.FC<GraficaIngresosProps> = ({ facturas }) => {
  // Procesar datos para la gráfica
  const datos = React.useMemo(() => {
    const hoy = new Date();
    const ultimos6Meses = Array.from({ length: 6 }, (_, i) => {
      const fecha = new Date(hoy.getFullYear(), hoy.getMonth() - i, 1);
      return {
        mes: fecha.toLocaleDateString('es-ES', { month: 'short' }),
        fecha
      };
    }).reverse();

    return ultimos6Meses.map(({ mes, fecha }) => {
      const ingresos = facturas
        .filter(f => {
          const facturaFecha = new Date(f.fecha);
          return facturaFecha.getMonth() === fecha.getMonth() &&
                 facturaFecha.getFullYear() === fecha.getFullYear() &&
                 f.estado === 'pagada';
        })
        .reduce((sum, f) => sum + f.total, 0);

      return {
        mes,
        ingresos
      };
    });
  }, [facturas]);

  return (
    <div className="h-[300px] opacity-0 animate-fade-in" style={{ animationDelay: '600ms', animationDuration: '600ms' }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={datos}>
          <defs>
            <linearGradient id="colorIngresos" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.3}/>
              <stop offset="95%" stopColor="#3b82f6" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            dataKey="mes"
            stroke="#6b7280"
            fontSize={12}
          />
          <YAxis
            tickFormatter={(value) => formatCurrency(value)}
            width={80}
            stroke="#6b7280"
            fontSize={12}
          />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey="ingresos"
            stroke="#3b82f6"
            strokeWidth={2}
            fill="url(#colorIngresos)"
            name="Ingresos"
            animationDuration={1000}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GraficaIngresos;